/* B4P – vídeos (stories + carrossel) sem app. Mímir, 03/11/2026 */
(function () {
  if (window.B4PV) return;
  var ICON = {
    x: '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none"/></svg>',
    l: '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
    r: '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
    on: '<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 8.5a5 5 0 010 7M18.5 6a8.5 8.5 0 010 12" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>',
    off: '<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16.5 9.5l5 5M21.5 9.5l-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    play: '<svg viewBox="0 0 24 24"><path d="M7 4.5v15l13-7.5z" fill="currentColor"/></svg>'
  };
  /* Vídeo: MP4 em 720p, igual ao Tolstoy (começa quase na hora). O endereço do 720p sai da lista
     de qualidades (.m3u8) que a Shopify gera para cada vídeo; se algo falhar, usa o MP4 do tema. */
  function mp4Of(el) {
    if (el._mp4) return el._mp4;
    var hls = el.dataset.b4pvHls, fb = el.dataset.b4pvSrc;
    el._mp4 = !hls ? Promise.resolve(fb) : fetch(hls).then(function (r) { return r.text(); }).then(function (t) {
      var lines = t.split('\n').filter(function (l) { return l && l.charAt(0) !== '#' && /\.m3u8/.test(l); }), pick = null;
      ['720p', '480p'].some(function (q) { pick = lines.filter(function (l) { return l.indexOf(q) > -1; })[0]; return !!pick; });
      var m = pick && pick.match(/^(.+)\.(HD|SD)-(\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8/);
      return m ? hls.replace(/[^\/]+\.m3u8.*$/, m[1] + '.' + m[2] + '-' + m[3] + '-' + m[4] + '-' + m[5] + '.mp4') : fb;
    }).catch(function () { return fb; });
    return el._mp4;
  }
  function attach(v, el) {
    return mp4Of(el).then(function (u) { if (u && v.getAttribute('src') !== u) v.src = u; });
  }

  /* ---------- Player ---------- */
  var modal, video, bar, bars, prods, btnPrev, btnNext, btnMute, items = [], idx = 0, muted = false, lastFocus;
  function build() {
    modal = document.createElement('div');
    modal.className = 'b4pv-modal b4pv-hidden';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Vídeo');
    modal.innerHTML =
      '<div class="b4pv-modal__box"><div class="b4pv-modal__stage">' +
      '<video playsinline preload="auto"></video>' +
      '<div class="b4pv-modal__bars"></div><span class="b4pv-modal__paused">' + ICON.play + '</span>' +
      '<button type="button" class="b4pv-modal__btn b4pv-modal__close" aria-label="Fechar">' + ICON.x + '</button>' +
      '<button type="button" class="b4pv-modal__btn b4pv-modal__mute" aria-label="Som">' + ICON.on + '</button>' +
      '<button type="button" class="b4pv-modal__btn b4pv-modal__prev" aria-label="Vídeo anterior">' + ICON.l + '</button>' +
      '<button type="button" class="b4pv-modal__btn b4pv-modal__next" aria-label="Próximo vídeo">' + ICON.r + '</button>' +
      '</div><div class="b4pv-modal__prods"></div></div>';
    document.body.appendChild(modal);
    video = modal.querySelector('video');
    bars = modal.querySelector('.b4pv-modal__bars');
    prods = modal.querySelector('.b4pv-modal__prods');
    btnPrev = modal.querySelector('.b4pv-modal__prev');
    btnNext = modal.querySelector('.b4pv-modal__next');
    btnMute = modal.querySelector('.b4pv-modal__mute');
    modal.querySelector('.b4pv-modal__close').addEventListener('click', close);
    btnPrev.addEventListener('click', function () { go(idx - 1); });
    btnNext.addEventListener('click', function () { go(idx + 1); });
    btnMute.addEventListener('click', function () { muted = !muted; video.muted = muted; btnMute.innerHTML = muted ? ICON.off : ICON.on; });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    video.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
    video.addEventListener('play', function () { modal.classList.remove('is-paused'); });
    video.addEventListener('pause', function () { modal.classList.add('is-paused'); });
    video.addEventListener('timeupdate', function () { if (video.duration && bar) bar.style.width = (video.currentTime / video.duration * 100) + '%'; });
    video.addEventListener('ended', function () { if (idx < items.length - 1) go(idx + 1); else close(); });
    document.addEventListener('keydown', function (e) {
      if (modal.classList.contains('b4pv-hidden')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(idx + 1);
      else if (e.key === 'ArrowLeft') go(idx - 1);
    });
    var y0 = null, x0 = null;
    modal.addEventListener('touchstart', function (e) {
      if (e.target.closest('.b4pv-modal__prods')) { y0 = null; return; } // mexer nos produtos não troca o vídeo
      y0 = e.touches[0].clientY; x0 = e.touches[0].clientX;
    }, { passive: true });
    modal.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var dy = e.changedTouches[0].clientY - y0, dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
      else if (dy > 90) close();
      else if (dy < -60) go(idx + 1);
      y0 = null;
    }, { passive: true });
  }
  function go(i) {
    if (i < 0 || i >= items.length) return;
    idx = i;
    var it = items[i];
    // barra dividida (um tracinho por story): anteriores cheios, seguintes vazios
    Array.prototype.forEach.call(bars.children, function (s, k) { s.firstChild.style.width = k < i ? '100%' : '0'; });
    bar = bars.children[i] && bars.children[i].firstChild;
    markSeen(it);
    if (it._coverV) { it._coverV.removeAttribute('src'); it._coverV.load(); it._coverV = null; } // capa ainda carregando: solta o arquivo para o story abrir
    video.poster = it.dataset.b4pvPoster || '';
    video.muted = muted;
    var token = {}; video._tok = token;
    attach(video, it).then(function () {
      if (video._tok !== token) return;
      var p = video.play();
      if (p && p.catch) p.catch(function () { muted = true; video.muted = true; btnMute.innerHTML = ICON.off; video.play().catch(function () {}); });
    });
    var tpl = it.querySelector('template.b4pv-tpl') || (it.closest('[data-b4pv-card]') || it).querySelector('template.b4pv-tpl');
    prods.innerHTML = tpl ? tpl.innerHTML : '';
    btnPrev.hidden = i === 0;
    btnNext.hidden = i === items.length - 1;
  }
  function open(list, i) {
    if (!modal) build();
    items = list;
    bars.innerHTML = list.map(function () { return '<span><i></i></span>'; }).join('');
    lastFocus = document.activeElement;
    modal.classList.remove('b4pv-hidden');
    document.documentElement.classList.add('b4pv-lock');
    document.querySelectorAll('.b4pv-thumb video').forEach(function (v) { v.pause(); });
    go(i);
    modal.querySelector('.b4pv-modal__close').focus();
  }
  function close() {
    video.pause();
    video._tok = null;
    video.removeAttribute('src');
    video.load();
    modal.classList.add('b4pv-hidden');
    document.documentElement.classList.remove('b4pv-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    document.querySelectorAll('[data-b4pv-carousel]').forEach(function (c) { if (c._b4pvUpdate) c._b4pvUpdate(); });
    if (pendingCart) { var st = pendingCart; pendingCart = null; showCart(st); }
  }

  /* ---------- Adicionar ao carrinho direto do vídeo ----------
     Dentro do player: atualiza o ícone do carrinho e avisa; o carrinho abre quando o vídeo for fechado.
     Fora do player: abre a gaveta do carrinho do tema na hora. */
  var pendingCart = null, toastT;
  function toast(msg) {
    var t = document.querySelector('.b4pv-toast');
    if (!t) { t = document.createElement('div'); t.className = 'b4pv-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 2200);
  }
  function cartEl() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function showCart(st) {
    var c = cartEl();
    if (c && c.renderContents) { try { c.classList.remove('is-empty'); c.renderContents(st); return true; } catch (_) {} }
    return false;
  }
  function updateBubble(st) {
    var html = st.sections && st.sections['cart-icon-bubble'], bub = document.getElementById('cart-icon-bubble');
    if (!html || !bub) return;
    var s = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (s) bub.innerHTML = s.innerHTML;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b4pv-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    var c = cartEl();
    var secs = c && c.getSectionsToRender ? c.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.b4pvAdd, quantity: 1 }], sections: secs.join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      b.classList.remove('is-busy');
      if (!res.ok) { toast(res.j.description || 'Não foi possível adicionar ao carrinho'); return; }
      b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1800);
      var st = res.j; if (st.items && st.items[0]) st.id = st.items[0].id;
      var inPlayer = modal && !modal.classList.contains('b4pv-hidden');
      if (!inPlayer && showCart(st)) return;
      updateBubble(st);
      if (inPlayer) pendingCart = st;
      toast('Adicionado ao carrinho ✓');
    }).catch(function () { b.classList.remove('is-busy'); toast('Não foi possível adicionar ao carrinho'); });
  }, true);

  /* ---------- Stories estilo Instagram ----------
     Story assistido fica com o anel cinza e vai para o fim da fila (guardado neste navegador).
     Capa: se a capa automática da Shopify for um quadro vazio (todo cinza/preto), mostra um quadro de ~1s do vídeo. */
  // Detecta capa vazia (quadro todo cinza/preto). Resultado guardado por endereço da imagem.
  var blankSrc = {};
  function checkBlank(img, cb) {
    if (!img) return;
    var key = img.getAttribute('src');
    if (key in blankSrc) { if (blankSrc[key] !== null) cb(blankSrc[key]); return; }
    blankSrc[key] = null;
    function run() {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        var b = false;
        try {
          var cv = document.createElement('canvas'); cv.width = 16; cv.height = 16;
          var x = cv.getContext('2d'); x.drawImage(im, 0, 0, 16, 16);
          var d = x.getImageData(0, 0, 16, 16).data, mn = 255, mx = 0;
          for (var k = 0; k < d.length; k += 4) { var g = (d[k] + d[k + 1] + d[k + 2]) / 3; if (g < mn) mn = g; if (g > mx) mx = g; }
          b = mx - mn <= 24;
        } catch (_) {}
        blankSrc[key] = b; cb(b);
      };
      im.src = img.currentSrc || img.src;
    }
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  }
  // Tarefas leves só depois que a página e o vídeo principal já carregaram
  function later(fn) {
    function go() { setTimeout(fn, 1500); }
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  var SEEN_KEY = 'b4pv_seen';
  function seenList() { try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]'); } catch (_) { return []; } }
  function markSeen(it) {
    var id = it && it.dataset.b4pvId; if (!id || !it.classList.contains('b4pv-story')) return;
    it.classList.add('is-seen');
    try { var l = seenList(); if (l.indexOf(id) < 0) { l.push(id); localStorage.setItem(SEEN_KEY, JSON.stringify(l.slice(-300))); } } catch (_) {}
  }
  function fixCover(st) {
    var img = st.querySelector('.b4pv-story__ring img');
    if (!img) return;
    checkBlank(img, function (blank) {
        if (!blank) return; // capa normal: não baixa nada
        var v = document.createElement('video');
        v.muted = true; v.playsInline = true; v.preload = 'metadata'; v.setAttribute('aria-hidden', 'true');
        v.addEventListener('loadedmetadata', function () { try { v.currentTime = Math.min(1, (v.duration || 3) / 3); } catch (_) {} }, { once: true });
        v.addEventListener('seeked', function () {
          // copia o quadro para uma imagem e solta o vídeo na hora (senão o navegador segura o arquivo e o story não abre)
          var S = 240, cv = document.createElement('canvas'); cv.width = S; cv.height = S;
          var vw = v.videoWidth, vh = v.videoHeight, m = Math.min(vw, vh);
          try { cv.getContext('2d').drawImage(v, (vw - m) / 2, (vh - m) / 2, m, m, 0, 0, S, S); img.replaceWith(cv); } catch (_) {}
          v.removeAttribute('src'); v.load(); st._coverV = null;
        }, { once: true });
        st._coverV = v;
        attach(v, st);
    });
  }
  function initStories(scope) {
    var seen = seenList();
    (scope || document).querySelectorAll('.b4pv-stories__row').forEach(function (row) {
      if (row._b4pvInit) return; row._b4pvInit = true;
      var all = Array.prototype.slice.call(row.querySelectorAll('.b4pv-story'));
      all.forEach(function (st) { if (seen.indexOf(st.dataset.b4pvId) > -1) st.classList.add('is-seen'); });
      later(function () { all.forEach(fixCover); });
      all.filter(function (st) { return st.classList.contains('is-seen'); }).forEach(function (st) { row.appendChild(st); }); // vistos vão pro fim
    });
  }

  /* ---------- Stories e cliques ---------- */
  document.addEventListener('click', function (e) {
    var it = e.target.closest('[data-b4pv-item]');
    if (!it) return;
    var g = it.closest('[data-b4pv-group]');
    var list = g ? Array.prototype.slice.call(g.querySelectorAll('[data-b4pv-item]')) : [it];
    e.preventDefault();
    open(list, list.indexOf(it));
  });

  /* ---------- Carrossel (estilo Tolstoy) ----------
     Infinito, sem rolagem nativa: cada card é posicionado por transform a partir de "pos"
     (índice do vídeo no centro, pode ser fracionário durante a animação). O tamanho cresce
     conforme o card se aproxima do centro, então não há "pulo". */
  var SOUND_ON = ICON.on, SOUND_OFF = ICON.off;
  function initCarousel(root) {
    if (root._b4pvInit) return;
    root._b4pvInit = true;
    var stage = root.querySelector('.b4pv-car__stage');
    var base = Array.prototype.slice.call(stage.querySelectorAll('[data-b4pv-card]'));
    var n = base.length;
    if (!n) return;
    var autoplay = root.dataset.autoplay === 'true';
    var cards = base.slice(), N, pos, W, G, HS, HA, slot, visible = false, sound = false, anim = null, active = null, finite = false;
    function px(v) { return parseFloat(v) || 0; }
    function measure() {
      var cs = getComputedStyle(root);
      W = base[0].offsetWidth; G = px(cs.getPropertyValue('--gap')) || 16;
      HS = W * (px(cs.getPropertyValue('--rS')) || 1.3); HA = W * (px(cs.getPropertyValue('--rA')) || 1.667);
      slot = W + G;
    }
    function ensureClones() {
      if (n < 2) return;
      while (cards.length * slot < stage.clientWidth + 3 * slot && cards.length < n * 8) {
        base.forEach(function (c) { var k = c.cloneNode(true); k.setAttribute('data-clone', ''); k.classList.remove('is-active'); stage.appendChild(k); cards.push(k); });
      }
      N = cards.length;
    }
    // Poucos vídeos (cabem todos na tela): sem rolagem infinita, para não repetir o mesmo vídeo na tela
    function visCount() { return 2 * Math.ceil(Math.max(0, stage.clientWidth / 2 - W / 2) / slot) + 1; }
    function setupLoop() {
      var was = finite;
      finite = n < visCount(); // sem rolagem infinita só se a seção tem menos vídeos que cabem na tela (senão repete)
      if (finite) {
        cards.slice(n).forEach(function (c) { release(c); c.remove(); });
        cards = base.slice(); N = n;
        if (pos != null) pos = Math.max(0, Math.min(n - 1, ((Math.round(pos) % n) + n) % n));
      } else { if (was) N = n; ensureClones(); }
      root.classList.toggle('is-finite', finite);
    }
    function isBlank(c) { var im = c && c.querySelector('.b4pv-thumb img'); return !!(im && blankSrc[im.getAttribute('src')]); }
    later(function () { base.forEach(function (c) { checkBlank(c.querySelector('.b4pv-thumb img'), function (b) { if (b && visible) setActive(); }); }); });
    function clampT(t) { return finite ? Math.max(0, Math.min(N - 1, t)) : t; }
    function wrap(d) { if (N < 2 || finite) return d; d = ((d % N) + N) % N; return d >= N / 2 ? d - N : d; }
    function mod(i) { return finite ? Math.max(0, Math.min(N - 1, i)) : ((i % N) + N) % N; }
    function layout() {
      var reach = stage.clientWidth / 2 / slot + 1.5;
      cards.forEach(function (c, i) {
        var d = wrap(i - pos), t = Math.max(0, 1 - Math.abs(d)), h = HS + (HA - HS) * t;
        c.style.transform = 'translate3d(' + (d * slot).toFixed(2) + 'px,' + ((HA - h) / 2).toFixed(2) + 'px,0)';
        c.firstElementChild.style.height = h.toFixed(2) + 'px';
        c.style.visibility = Math.abs(d) > reach ? 'hidden' : '';
        c.style.zIndex = String(100 - Math.round(Math.abs(d) * 2));
      });
    }
    // full = vídeo que vai tocar (baixa normal); vizinhos só deixam o começo pronto, sem disputar a internet
    function prep(c, full) {
      var v = c && c.querySelector('.b4pv-thumb video');
      if (!v) return null;
      v.preload = full ? 'auto' : 'metadata';
      if (!v._b4pvReady) v._b4pvReady = attach(v, c.querySelector('.b4pv-thumb'));
      // Capa vazia (1º quadro todo cinza/preto): mostra um quadro de ~1s. Capa normal: continua a foto, sem baixar nada a mais.
      if (!full && isBlank(c) && !v._b4pvSeek) {
        v._b4pvSeek = true;
        var seek = function () { if (v.paused && v.currentTime < 0.3) { try { v.currentTime = Math.min(1, (v.duration || 3) / 3); } catch (_) {} } };
        v.addEventListener('seeked', function () { if (v._b4pvReady) v.classList.add('is-on'); }, { once: true });
        if (v.readyState >= 1) seek(); else v.addEventListener('loadedmetadata', seek, { once: true });
      }
      return v._b4pvReady;
    }
    function release(c) {
      var v = c.querySelector('.b4pv-thumb video');
      if (!v || !v._b4pvReady) return;
      v.pause(); v.classList.remove('is-on'); v.removeAttribute('src'); v.load(); v._b4pvReady = null; v._b4pvSeek = false;
    }
    function play(c) {
      var v = c.querySelector('.b4pv-thumb video');
      if (!v) return;
      v.muted = !sound;
      prep(c, true).then(function () {
        if (active !== c || !visible || c._paused) return;
        var p = v.play();
        if (p && p.then) p.then(function () { v.classList.add('is-on'); }).catch(function () {});
      });
    }
    function setActive(idx) {
      var i0 = idx == null ? mod(Math.round(pos)) : mod(idx), c = cards[i0];
      var keep = [i0, mod(i0 + 1), mod(i0 - 1)];
      for (var k = 2, h = (visCount() - 1) / 2; k <= h; k++) [mod(i0 + k), mod(i0 - k)].forEach(function (j) { if (isBlank(cards[j])) keep.push(j); }); // mais longe: só os de capa vazia
      cards.forEach(function (o, j) { if (keep.indexOf(j) < 0) release(o); });
      if (visible) keep.slice(1).forEach(function (j) { prep(cards[j], false); });
      if (c !== active) {
        if (active) { active.classList.remove('is-active'); closeLists(); }
        active = c; c.classList.add('is-active'); c._paused = false;
      }
      cards.forEach(function (o) { var v = o.querySelector('.b4pv-thumb video'); if (o !== active && v && !v.paused) v.pause(); });
      if (autoplay && visible) play(active); else if (active) { var v = active.querySelector('.b4pv-thumb video'); if (v) v.pause(); }
      syncMute();
    }
    function syncMute() { cards.forEach(function (c) { var b = c.querySelector('.b4pv-mute'); if (b) { b.innerHTML = sound ? SOUND_ON : SOUND_OFF; b.setAttribute('aria-label', sound ? 'Desativar som' : 'Ativar som'); } }); }
    function closeLists() { root.querySelectorAll('.b4pv-prod.is-open').forEach(function (b) { b.classList.remove('is-open'); b.querySelector('.b4pv-prod__list').hidden = true; b.querySelector('.b4pv-prod__tog').setAttribute('aria-expanded', 'false'); }); }
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function goTo(target, ms) {
      if (N < 2) return;
      if (anim) cancelAnimationFrame(anim.raf);
      target = clampT(target);
      var from = pos, diff = wrap(target - from), t0 = performance.now(), dur = ms || 550;
      if (Math.abs(diff) < 0.001) { pos = mod(Math.round(target)); layout(); setActive(); return; }
      anim = {};
      setActive(mod(Math.round(from + diff))); // já começa a tocar o próximo durante o movimento
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur);
        pos = from + diff * ease(k);
        layout();
        if (k < 1) anim.raf = requestAnimationFrame(step);
        else { anim = null; pos = mod(Math.round(pos)); layout(); }
      })(t0);
    }
    // arrastar / deslizar
    var drag = null, moved = false;
    stage.addEventListener('pointerdown', function (e) {
      if (N < 2 || e.button > 0 || e.target.closest('.b4pv-prod,.b4pv-mute')) return;
      if (anim) { cancelAnimationFrame(anim.raf); anim = null; }
      drag = { x: e.clientX, y: e.clientY, p: pos, t: performance.now(), id: e.pointerId, on: false }; moved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.on) { if (Math.abs(dx) < 12 || Math.abs(dx) < Math.abs(dy) * 1.4) { if (Math.abs(dy) > 12) drag = null; return; } drag.on = true; moved = true; try { stage.setPointerCapture(e.pointerId); } catch (_) {} }
      pos = drag.p - Math.max(-1, Math.min(1, dx / slot));
      if (finite) pos = Math.max(-0.25, Math.min(N - 0.75, pos));
      layout();
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var d = drag; drag = null;
      if (!d.on) return;
      var moveBy = d.p - pos, px = Math.abs(moveBy) * slot, start = Math.round(d.p);
      var target = start; // igual ao Tolstoy: menos de ~50 px volta; mais que isso passa SÓ 1 vídeo, mesmo com força
      if (px > 50) target = start + (moveBy < 0 ? 1 : -1);
      goTo(target, 420);
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    stage.addEventListener('click', function (e) {
      if (moved) { moved = false; e.preventDefault(); e.stopPropagation(); return; }
      var mb = e.target.closest('.b4pv-mute');
      if (mb) {
        e.preventDefault(); sound = !sound; syncMute();
        var v = active && active.querySelector('.b4pv-thumb video');
        if (v) { v.muted = !sound; if (sound && v.paused) { active._paused = false; play(active); } }
        return;
      }
      var tg = e.target.closest('.b4pv-prod__tog');
      if (tg) {
        e.preventDefault();
        var box = tg.closest('.b4pv-prod'), list = box.querySelector('.b4pv-prod__list'), open = !box.classList.contains('is-open');
        closeLists();
        if (open) { box.classList.add('is-open'); list.hidden = false; tg.setAttribute('aria-expanded', 'true'); }
        return;
      }
      var th = e.target.closest('.b4pv-thumb');
      if (!th) return;
      var c = th.closest('[data-b4pv-card]'), i = cards.indexOf(c);
      if (c === active) {
        var v = c.querySelector('.b4pv-thumb video');
        if (!v) return;
        if (v.paused) { c._paused = false; play(c); } else { c._paused = true; v.pause(); }
      } else { goTo(pos + wrap(i - pos)); }
    }, true);
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.round(pos) + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.round(pos) - 1); }
    });
    function refresh() { measure(); if (n > 1) setupLoop(); layout(); setActive(); }
    measure(); setupLoop(); if (!N) N = cards.length;
    pos = n > 1 ? Math.floor(n / 2) : 0;
    layout(); setActive();
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(refresh, 120); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; setActive(); }, { threshold: 0.4 }).observe(stage);
    } else { visible = true; setActive(); }
    root._b4pvUpdate = setActive;
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-b4pv-carousel]').forEach(initCarousel); initStories(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.B4PV = { open: open, init: initAll };
})();
